import type {GenericContent} from '../../../../../../brand/lib/types/contentful'

import {MediaAsset} from '../../_shared/MediaAsset/MediaAsset'

import Styles from './Media.module.css'

type Props = {
  content: GenericContent
  location: string
  loading?: 'eager' | 'lazy'
}

export function Media(props: Props) {
  const {content, location, loading} = props

  const {media} = content.fields

  return (
    <div className={Styles.Media}>{media && <MediaAsset content={media} location={location} loading={loading} />}</div>
  )
}

try{ Media.displayName ||= 'Media' } catch {}